export { LogRocket, initialize } from './logrocket'
